import {
  Columns,
  Icon,
  Radio,
  Stack,
  Text,
} from '@lightspeed/design-system-react'
import { T, useT } from '@transifex/react'
import React from 'react'
import { ShouldFulfillOpt } from './LineItemFulfillmentContext'

export const TContext = 'Line item fulfilment popover'
export const TestId = 'lif-decision-view'

type Props = {
  decision: ShouldFulfillOpt
  productQuantity: number
  productName: string
  onSelect: (opt: ShouldFulfillOpt) => void
}

export const LineItemFulfilmentDecisionView: React.FC<Props> = ({
  decision,
  productQuantity,
  productName,
  onSelect,
}: Props) => {
  const t = useT()
  return (
    <Stack space={6} data-testid={TestId}>
      <Columns space={2}>
        <Text type="label">
          <Icon
            icon="fa-exclamation-triangle"
            className="wr-input-error-icon"
          />
        </Text>
        <Text type="label">
          <h3>
            {t(
              '{productQuantity, plural,' +
                'one {There’s {productQuantity} available of “{productName}”}' +
                'other {There’s {productQuantity} available of “{productName}”}}',
              { _context: TContext, productQuantity, productName }
            )}
          </h3>
        </Text>
      </Columns>

      <Stack space={2}>
        <Text type="label">
          <T _str="What do you want to do?" _context={TContext} />
        </Text>
        <Stack space={2}>
          <Radio
            className="vd-pl0"
            name="decision"
            label={t('Continue anyway', { _context: TContext })}
            value={ShouldFulfillOpt.NO}
            checked={decision === ShouldFulfillOpt.NO}
            onChange={() => onSelect(ShouldFulfillOpt.NO)}
          />
          <Radio
            className="vd-pl0"
            name="decision"
            label={t('Fulfill later', { _context: TContext })}
            value={ShouldFulfillOpt.YES}
            checked={decision === ShouldFulfillOpt.YES}
            onChange={() => onSelect(ShouldFulfillOpt.YES)}
          />
        </Stack>
      </Stack>
    </Stack>
  )
}
